import { useProductImageOrderHook } from '../hooks/use-product-image-order.hook'
import { ProductImageOrderInterface } from '../interfaces/product-image-order.interface'

export function ProductImageOrderContainer() {
  const productImageOrderHook = useProductImageOrderHook()

  return <ProductImageOrderInterface productImages={productImageOrderHook} />
}
